<template>
  <div class="bj">
    <!-- <div class="wrap"> -->
      <img src="../assets/images/logo.png" alt="" class="logo">
      <div class="content">
        

        
        <div class="title">
          <div class="t">Net Zero Trip Card</div>
          <div class="xian"></div>
          <!-- <div class="h_title">{{$t('login.tips')}}</div> -->
        </div> 
        <div class="pa">
          <div class="con_form">
          <div class="logIn">Log In</div>
          <el-form ref="loginForm"
            :model="loginForm"
            :rules="rules">
            <el-form-item label="Username" prop="username">
              <el-input v-model="loginForm.username"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input v-model="loginForm.password" show-password></el-input>
              <div class="forgot">
                Forgot Your Password?
              </div>
            </el-form-item>
          </el-form>

          <div class="bth_wrap">
            <el-button class="login" @click="login">Log In</el-button>
          </div>
        </div>
        </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import user from '@/api/user'
export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      loginResult: "",
      passwordType: "password",
      rules: {
        username: [
          {
            required: true,
            message: "Please input user name",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Please input password",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    login() {
      this.$refs["loginForm"].validate(valid => {
        if (valid) {
          user.getCheckUserInfo(res => {
            if(res.code == 200){
              sessionStorage.setItem('user',JSON.stringify(res.data))
              this.$router.push('/cardManagement')
            }else{
              this.$message.error(res.message)
            }
            
          },this.loginForm)
        }else {
          return false;
        }
      })
      
    }
  },
};
</script>

<style lang="scss" scoped>
.bj{
  width: 100%;
  height: 100vh;
  // min-height: 100%;
  background: url('../assets/images/bj.png') no-repeat ;
  background-size: 100% 100%;
  position: relative;
  // .wrap{
    // margin: 120px 239px 125px 45px;
    .logo{
      width: 297px;
      height: 57px;
      position:absolute;
      top: 35px;
      left: 45px;
    }
    .content{
      display: flex;
      justify-content: center;
      width: 80%;
      // padding: 100px 139px 120px 139px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      .title{
        width: 1000px;
        margin-top: 100px;
        .t{
          font-size:60px;
          font-family: Gotham Regular;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 106px;
        }
        .xian{
          display: inline-block;
          width: 108px;
          opacity: 0.29;
          border-bottom: 10px solid #FFFFFF;
          border-radius: 10px;
        }
        .h_title{
          font-size: 18px;
          font-family: Gotham Regular;
          font-weight: 100;
          color: #FFFFFF;
          margin-top: 98px;
        }
      }
      .pa{
        width: 510px;
        height: 500px;
        position: relative;
        .con_form{
          height: 100%;
          background: #FFFFFF;
          border-radius: 20px;
          padding:50px 60px 0px;
          .logIn{
            font-size: 40px;
            font-family: Arial-BoldMT, Arial;
            font-weight: bold;
            color: #1E1E1E;
            text-align: center;
            margin-bottom: 50px;
          }
          .login{
            width: 100%;
            height: 56px;
            background: #158869;
            border-radius: 10px;
            color: #ffffff;
            font-size: 16px;
            font-family: Gotham Regular;
            margin-bottom: 50px;
          }
          .signUp{
            text-align: center;
            font-size: 16px;
            font-family: Gotham Regular;
            color: #158869;
            margin-top: 20px;
          }
        }
      }
      
    }
  // }
}
.bth_wrap{
  width: 74%;
  position: absolute;
  bottom: 0px;
}
.forgot{
  text-align: right;
  font-size: 14px;
  font-family: Gotham Regular;
  color: #498D86;
}
.tips{
  text-align: left;
  font-size: 14px;
  font-family: Gotham Regular;
  color: red;
}
::v-deep .el-form-item:first-child{
  margin-bottom: 10px;
}
::v-deep .el-form-item__label{
  font-size: 16px;
  font-family: Gotham Regular;
  color: #366F67;
}
::v-deep .el-input__inner{
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #E1E1E1;
  padding: 0;
  // margin-top: 20px;
}
::v-deep .el-form-item{
  margin-bottom: 0;
}
::v-deep .el-input__inner:focus{
  border-bottom: 1px solid #E1E1E1;
}

::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    -webkit-text-fill-color: #333;
}

::v-deep .el-icon-view:before{
  font-size: 22px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue